import { Toolbar, Stack, Typography, Divider, Link } from "@mui/material";
import Logo from "./Logo";
import PhoneIcon from "@mui/icons-material/Phone";
import ViewCart from "./ViewCart";
import theme from "../styles/themes/theme";

const TopToolbar = () => {
  return (
    <Toolbar
      sx={{
        minHeight: { xs: "2.5rem", sm: "3rem" },
        backgroundColor: "white",
        justifyContent: "space-between",
        py: { xs: theme.spacing(0.5), sm: theme.spacing(1) },
        ml: {
          xs: theme.spacing(1),
          sm: theme.spacing(2),
          md: theme.spacing(12),
        },
      }}
    >
      <Stack
        direction="row"
        spacing={{
          xs: theme.spacing(1),
          sm: theme.spacing(2),
          md: theme.spacing(3),
        }}
        sx={{ alignItems: "center" }}
      >
        <Logo />
      </Stack>
      <Stack
        direction="row"
        spacing={{
          xs: theme.spacing(0.5),
          sm: theme.spacing(1),
          md: theme.spacing(2),
        }}
        sx={{
          alignItems: "center",
          mr: {
            xs: theme.spacing(2),
            sm: theme.spacing(2),
            md: theme.spacing(12),
          },
        }}
      >
        <Link
          href="tel:8005826366"
          underline="none"
          aria-label="Call 800-582-6366"
        >
          <PhoneIcon sx={{ color: "#c82027" }} />
          <Typography
            sx={{
              display: { xs: "none", sm: "inline-block" },
              fontFamily: "Roboto",
              fontSize: { xs: "0.875rem", sm: "1rem" },
              color: "black",
              fontWeight: 500,
              ml: theme.spacing(0.5),
            }}
          >
            800-582-6366
          </Typography>
        </Link>
        <Divider
          orientation="vertical"
          variant="middle"
          sx={{ mx: theme.spacing(1) }}
          flexItem
        />
        <ViewCart />
      </Stack>
    </Toolbar>
  );
};

export default TopToolbar;
